import type { CompanyFactorySummary } from '@indutrust/factory-model';
import { createCrudEvents } from '@indutrust/shared-util';

/**
 * Events for CRUD operations on the company-scoped factories collection.
 *
 * Manages the complete lifecycle of company factory data operations:
 * - loadAll, loadById, add, edit, delete
 * Each operation has request, success, and failure variants.
 *
 * Payloads carry {@link CompanyFactorySummary} (the lightweight
 * projection returned by `GET /companies/{companyId}/factories`) — the
 * full {@link import('@indutrust/factory-model').FactoryEdit} model is
 * fetched on demand by the detail/edit page.
 *
 * Uses 'factory.company-factories' as the event source namespace for Redux DevTools debugging.
 *
 * @example
 * const dispatch = injectDispatch(companyFactoriesCrudEvents);
 * dispatch.loadAllRequested({ params: {} });
 */
export const companyFactoriesCrudEvents =
  createCrudEvents<CompanyFactorySummary>('company-factories');
